/**
 * Fera.ai Reviews - Change Dates and Number of Reviews
 *
 * Changes the dates of the reviews so they appear to be recent
 *
 * Changes the number of reviews to a number between 1324 and 1669
 *
 * Include the script in the main-product.liquid file with this line:
 *
 * <script src="{{ 'review-dates.js' | asset_url }}" defer="defer"></script>
 */

// Using the MutationObserver, we can detect when the widget is loaded
function waitForElm(selector) {
    return new Promise((resolve) => {
        if (document.querySelector(selector)) {
            return resolve(document.querySelector(selector));
        }

        const observer = new MutationObserver((mutations) => {
            if (document.querySelector(selector)) {
                resolve(document.querySelector(selector));
                observer.disconnect();
            }
        });

        observer.observe(document.body, {
            childList: true,
            subtree: true,
        });
    });
}

// Using the MutationObserver, we can detect when the widget is loaded
// This function will check the number of elements of a kind loaded
// and, if it's equal to the number we want, resolve the promise
function waitForMoreElm(selector, numberOfElms) {
    return new Promise((resolve) => {
        const observer = new MutationObserver((mutations) => {
            let values = document.querySelectorAll(selector);
            if (values.length === numberOfElms) {
                resolve(values);
                observer.disconnect();
            }
        });

        observer.observe(document.body, {
            childList: true,
            subtree: true,
        });
    });
}

function randomIntFromInterval(min, max) {
    // min and max included
    return Math.floor(Math.random() * (max - min + 1) + min);
}

// The times, in order, of the reviews, for all languages
const possibleTimes = {
    en: [
        "51 minutes ago",
        "2 hours ago",
        "4 hours ago",
        "6 hours ago",
        "6 hours ago",
        // 5
        "9 hours ago",
        "11 hours ago",
        "11 hours ago",
        "16 hours ago",
        "17 hours ago",
        // 10
        "1 day ago",
        "2 days ago",
        "2 days ago",
        "2 days ago",
        "2 days ago",
        // 15
        "3 days ago",
        "3 days ago",
        "4 days ago",
        "4 days ago",
        "4 days ago",
        // 20
        "5 days ago",
        "5 days ago",
        "5 days ago",
        "5 days ago",
        "6 days ago",
        // 25
        "6 days ago",
        "7 days ago",
        "7 days ago",
        "9 days ago",
        "9 days ago",
        // 30
    ],
    fr: [
        "Il y a 51 minutes",
        "Il y a 2 heures",
        "Il y a 4 heures",
        "Il y a 6 heures",
        "Il y a 6 heures",
        // 5
        "Il y a 9 heures",
        "Il y a 11 heures",
        "Il y a 11 heures",
        "Il y a 16 heures",
        "Il y a 17 heures",
        // 10
        "Il y a 1 jour",
        "Il y a 2 jours",
        "Il y a 2 jours",
        "Il y a 2 jours",
        "Il y a 2 jours",
        // 15
        "Il y a 3 jours",
        "Il y a 3 jours",
        "Il y a 4 jours",
        "Il y a 4 jours",
        "Il y a 4 jours",
        // 20
        "Il y a 5 jours",
        "Il y a 5 jours",
        "Il y a 5 jours",
        "Il y a 5 jours",
        "Il y a 6 jours",
        // 25
        "Il y a 6 jours",
        "Il y a 7 jours",
        "Il y a 7 jours",
        "Il y a 9 jours",
        "Il y a 9 jours",
        // 30
    ],
    de: [
        "vor 51 Minuten",
        "vor 2 Stunden",
        "vor 4 Stunden",
        "vor 6 Stunden",
        "vor 6 Stunden",
        // 5
        "vor 9 Stunden",
        "vor 11 Stunden",
        "vor 11 Stunden",
        "vor 16 Stunden",
        "vor 17 Stunden",
        // 10
        "vor 1 Tag",
        "vor 2 Tagen",
        "vor 2 Tagen",
        "vor 2 Tagen",
        "vor 2 Tagen",
        // 15
        "vor 3 Tagen",
        "vor 3 Tagen",
        "vor 4 Tagen",
        "vor 4 Tagen",
        "vor 4 Tagen",
        // 20
        "vor 5 Tagen",
        "vor 5 Tagen",
        "vor 5 Tagen",
        "vor 5 Tagen",
        "vor 6 Tagen",
        // 25
        "vor 6 Tagen",
        "vor 7 Tagen",
        "vor 7 Tagen",
        "vor 9 Tagen",
        "vor 9 Tagen",
        // 30
    ],
    es: [
        "Hace 51 minutos",
        "Hace 2 horas",
        "Hace 4 horas",
        "Hace 6 horas",
        "Hace 6 horas",
        // 5
        "Hace 9 horas",
        "Hace 11 horas",
        "Hace 11 horas",
        "Hace 16 horas",
        "Hace 17 horas",
        // 10
        "Hace 1 día",
        "Hace 2 días",
        "Hace 2 días",
        "Hace 2 días",
        "Hace 2 días",
        // 15
        "Hace 3 días",
        "Hace 3 días",
        "Hace 4 días",
        "Hace 4 días",
        "Hace 4 días",
        // 20
        "Hace 5 días",
        "Hace 5 días",
        "Hace 5 días",
        "Hace 5 días",
        "Hace 6 días",
        // 25
        "Hace 6 días",
        "Hace 7 días",
        "Hace 7 días",
        "Hace 9 días",
        "Hace 9 días",
        // 30
    ],
    "pt-BR": [
        "há 51 minutos",
        "há 2 horas",
        "há 4 horas",
        "há 6 horas",
        "há 6 horas",
        // 5
        "há 9 horas",
        "há 11 horas",
        "há 11 horas",
        "há 16 horas",
        "há 17 horas",
        // 10
        "há 1 dia",
        "há 2 dias",
        "há 2 dias",
        "há 2 dias",
        "há 2 dias",
        // 15
        "há 3 dias",
        "há 3 dias",
        "há 4 dias",
        "há 4 dias",
        "há 4 dias",
        // 20
        "há 5 dias",
        "há 5 dias",
        "há 5 dias",
        "há 5 dias",
        "há 6 dias",
        // 25
        "há 6 dias",
        "há 7 dias",
        "há 7 dias",
        "há 9 dias",
        "há 9 dias",
        // 30
    ],
    it: [
        "51 minuti fa",
        "2 ore fa",
        "4 ore fa",
        "6 ore fa",
        "6 ore fa",
        // 5
        "9 ore fa",
        "11 ore fa",
        "11 ore fa",
        "16 ore fa",
        "17 ore fa",
        // 10
        "1 giorno fa",
        "2 giorni fa",
        "2 giorni fa",
        "2 giorni fa",
        "2 giorni fa",
        // 15
        "3 giorni fa",
        "3 giorni fa",
        "4 giorni fa",
        "4 giorni fa",
        "4 giorni fa",
        // 20
        "5 giorni fa",
        "5 giorni fa",
        "5 giorni fa",
        "5 giorni fa",
        "6 giorni fa",
        // 25
        "6 giorni fa",
        "7 giorni fa",
        "7 giorni fa",
        "9 giorni fa",
        "9 giorni fa",
        // 30
    ],
};

// Variables and constants

// 1) Update the review times
const reviewDateSelector = ".fera-productReviews-review-date-val";
let timesUpdated = 0;
let showMoreButton;

// 2) Update the number of reviews
const reviewStarsCountSelector = "p.rating-count.caption > span:nth-child(1)";
const reviewWidgetCountSelector = ".fera-productReviews-reviewCount";
const reviewWidgetWaitFor = ".fera-productReviews-review";
const randomNumber = randomIntFromInterval(1324, 1669);

// Functions start here

// This function is called when the widget is loaded
function fixDates() {
    // Select all the reviews dates
    let allTimeDivs = Array.from(document.querySelectorAll(reviewDateSelector));

    // Since we don't want to update dates we already updated,
    // we keep the index of the last updated date and
    // only update the ones after that by slicing the array
    let timeDivs = allTimeDivs.slice(timesUpdated);

    // Check if the "Show more" button is present, if not, query it
    if (showMoreButton == null) {
        showMoreButton = document.querySelector(
            ".fera-productReviews-showMore"
        );
      const showMoreRealBtn = document.querySelector(".fera-productReviews-showMore-btn");

        // On click, wait for the new reviews to load and update the dates
        // Disable the button to avoid multiple clicks
        showMoreButton.addEventListener("click", (e) => {
            showMoreButton.style.pointerEvents = "none";
            waitForMoreElm(
                reviewDateSelector,
                timesUpdated + 5 // How many reviews need to be loaded
            ).then((element) => fixDates());
        });

        showMoreRealBtn.addEventListener("click", (e) => {
              showMoreRealBtn.style.pointerEvents = "none";
              waitForMoreElm(
                  reviewDateSelector,
                  timesUpdated + 5 // How many reviews need to be loaded
              ).then((element) => fixDates());
          });
    }

    // Get the language of the page
    let lang = Shopify.locale;

    // For each review, change the to the correct date
    for (var timeDiv of timeDivs) {
        timeDiv.innerText = possibleTimes[lang][timesUpdated];

        // Keep track of how many times the dates have been updated
        timesUpdated++;
    }

    // Re-enable the button
    showMoreButton.style.pointerEvents = "auto";
}

function changeNumberOfReviewsStars(element) {
    const str = "(" + randomNumber + ")";
    element.innerText = str;
}

// We wait for the body to load, else element will get replaced
function changeNumberOfReviewsWidget() {
    const str = "" + randomNumber;
    const element = document.querySelector(reviewWidgetCountSelector);
    element.innerText = str;
}

// 1) Change the dates
waitForElm(reviewDateSelector).then((element) => fixDates());

// 2) Change the number of reviews in the star count
waitForElm(reviewStarsCountSelector).then((element) => {
    changeNumberOfReviewsStars(element);
});

// 3) Change the number of reviews in the widget
// We wait for the body to load, else element will get replaced
waitForElm(reviewWidgetWaitFor).then((element) => {
    // You can remove the timeout
    // setTimeout(changeNumberOfReviewsWidget, 2000);
    changeNumberOfReviewsWidget();
});
